import React from "react";
import { Row, Col } from "reactstrap";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

import { useSelector } from "react-redux";

const RaffleWinnerAnnouncement = ({ hideButton }, context) => {
  const lang = useSelector((state) => state.i18nState.lang);

  return (
    <Row className="d-flex justify-content-between my-5 py-5 bg-secondary">
      <Col xs={12} md={4} className="py-md-5">
        <p className="fs-5">{context.t("Congratulations")}</p>
        <h2 className="text-white h1">{context.t("Raffle Winners")}</h2>
      </Col>
      <Col xs={12} md={6} className="align-items-center align-self-center">
        <p
          dangerouslySetInnerHTML={{
            __html: context.t("faq.roadmap.ninth.answer"),
          }}
        />
        {!hideButton && (
          <p className="text-end">
            <NavLink
              to={`/${lang}/raffle-unlock`}
              className="btn btn-primary w-100 rounded-pill py-2"
            >
              {context.t("Click here to check MX1 GE Winner Tokens")}
            </NavLink>
          </p>
        )}
      </Col>
    </Row>
  );
};

/**  define proptype for the 'translation' function  */
RaffleWinnerAnnouncement.contextTypes = {
  t: PropTypes.func,
};

RaffleWinnerAnnouncement.propTypes = {
  hideButton: PropTypes.bool,
};

RaffleWinnerAnnouncement.defaultProps = {};

export default RaffleWinnerAnnouncement;
